import axios from 'axios';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { removeBaseUrl } from '../../utils';
import { SkeletonBlogItem } from '../../components/comment/SkeletonBlogItem';

import './styles.scss';
const Blog = () => {
    const [isFetching, setIsFetching] = useState(false);
    const [blogs, setBlogs] = useState([]);
    const [categories, setCategories] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const location = useLocation();
    const [hasMore, setHasMore] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isFetchingCategories, setIsFetchingCategories] = useState(true);    
    const [keyword, setKeyword] = useState("");
    const navigate = useNavigate();
    

    useEffect(() => {
        window.scrollTo(0, 0);
        // document.title = 'Blogs - Wood Edwards';
        fetchCategories();
    }, []);

    useEffect(() => {
        
      const queryParams = new URLSearchParams(window.location.search);
      const paramValue = queryParams.get('keyword');
      setKeyword(paramValue);
      setPageNo(1);
      
    }, [location]);

    const fetchCategories = async () => {
        try {
            const { data } = await axios.get('/wp-admin/admin-ajax.php?action=get_all_categories');
            setCategories(data?.categories ?? []);
        } catch (e) {
            setCategories([]);
        } finally {
            setIsFetchingCategories(false);
        }
    }

    const fetchBlogs = async (pageNo, keyword, cat_id) => {
        if (isFetching) {
            return;
        }
        if (pageNo == 1) {
            setBlogs([]);
        }

        try {
            setIsFetching(true);
            const { data } = await axios.get(keyword ? `/wp-admin/admin-ajax.php?action=get_blogs_by_page&page_number=${pageNo}&posts_per_page=6&keyword=${keyword}&cat_id=${cat_id?cat_id:-1}` : `/wp-admin/admin-ajax.php?action=get_blogs_by_page&page_number=${pageNo}&posts_per_page=6&cat_id=${cat_id?cat_id:-1}`);
            if (data?.blogs?.length > 5) {
                setHasMore(true);
            } else {
                setHasMore(false);
            }

            if (pageNo === 1) {
                setBlogs([
                    // ...blogs,
                    ...data?.blogs ?? []
                ]);
            } else {
                setBlogs([
                    ...blogs,
                    ...data?.blogs ?? []
                ]);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        fetchBlogs(pageNo, keyword, selectedCategory);
    }, [pageNo]);

    const onClickSearchButton = () => {
        setPageNo(1);
        setBlogs([]);
        fetchBlogs(1, keyword, selectedCategory);
    }


    const onClickCategory = (cat) => {
        if (cat.term_id === selectedCategory) {
            setSelectedCategory(null);
        } else {
            setSelectedCategory(cat.term_id);
        }
        setBlogs([]);
        fetchBlogs(1, keyword, cat.term_id);
    }

    console.log(categories);
    
    return  <div className='legal-blog'>

        <section id="banner" className='blog-banner'>
            <div className='inner-wrapper'>
                <div className='banner-left-section'>
                    <h1>Articles & FAQ</h1>
                    <p>
                        Our articles are read by over 15,000 folks each month. Join them by searching your topic to find articles that will help you understand your issue and your options.
                    </p>
                </div>

                <div className='banner-right-section'>
                    <div className='tags-wrapper'>
                        {
                            isFetchingCategories && [1,2,3,4,5,6,7,8].map(it => {
                                return <div className='tag-skeleton' key={it}>
                                    <Skeleton width={"120px"} height="24px" />
                                </div>
                            })
                        }
                        {
                            !isFetchingCategories && categories?.length > 0 && categories?.map((it, index) => {
                                return <span className={`tag-item ${selectedCategory == it.term_id ? 'active' : ''}`} key={index} onClick={() => {
                                    onClickCategory(it);
                                }}>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#024953"/>
                                    </svg>
                                    {it.name} 
                                </span>
                            })
                        }
                    </div>

                    <div className='search-form-wrapper'>
                        <input type="text" placeholder='Search articles by keyword' onChange={(e) => {
                            setKeyword(e.target.value)
                        }} />
                        <button type="button" className='btn-search' onClick={() => {
                            onClickSearchButton()
                        }}>
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.57143 0C7.04906 0 8.46618 0.586988 9.51102 1.63183C10.5559 2.67668 11.1429 4.09379 11.1429 5.57143C11.1429 6.95143 10.6371 8.22 9.80571 9.19714L10.0371 9.42857H10.7143L15 13.7143L13.7143 15L9.42857 10.7143V10.0371L9.19714 9.80571C8.22 10.6371 6.95143 11.1429 5.57143 11.1429C4.09379 11.1429 2.67668 10.5559 1.63183 9.51102C0.586988 8.46618 0 7.04906 0 5.57143C0 4.09379 0.586988 2.67668 1.63183 1.63183C2.67668 0.586988 4.09379 0 5.57143 0ZM5.57143 1.71429C3.42857 1.71429 1.71429 3.42857 1.71429 5.57143C1.71429 7.71429 3.42857 9.42857 5.57143 9.42857C7.71429 9.42857 9.42857 7.71429 9.42857 5.57143C9.42857 3.42857 7.71429 1.71429 5.57143 1.71429Z" fill="white"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section id="posts-wrapper-container" className='blogs-list'>
            <div className='posts-wrapper'>
                    {
                        <div className='posts-repeater'>
                            {
                                blogs?.length > 0 && blogs?.map((it, index) => {
                                    return <div className='blog-item' key={index}>
                                                <Link to={removeBaseUrl(it?.permalink)} className='blog-title'>
                                                    {it?.title}
                                                </Link>
                                                <div className='blog-meta'>
                                                    <span className='author'>By {it?.author_name}</span>
                                                    <span className='category'>
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="5" cy="5" r="5" fill="#024953"/>
                                                        </svg>
                                                        {it?.category?.name}
                                                    </span>
                                                </div>
                                                <span className='excerpt'>
                                                    {it?.excerpt?.length > 100 ? `${it?.excerpt?.substring(0, 100)}...` : it.excerpt} <Link to={removeBaseUrl(it?.permalink)}>Read more</Link>
                                                </span>
                                        </div>
                                })

                            }
                            {
                                isFetching && [1, 2, 3, 4, 5, 6]?.map(it => {
                                    return <SkeletonBlogItem key={it} />
                                })
                            }
                        </div>
                    }
                    {
                        !isFetching && blogs?.length < 1 && <div className='no-blogs'>No Blogs</div>
                    }

                    { hasMore && <div className='more-link'>
                        <button className='button' onClick={() => {
                            setPageNo(pageNo + 1)
                        }}>
                            {isFetching ? 'Loading...' : 'Load more'}
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_1516_237" style={{ maskType: "alpha" }}maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                    <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#mask0_1516_237)">
                                    <path d="M12 15L7 10H17L12 15Z" fill="white"/>
                                </g>
                            </svg>

                        </button>
                    </div>}
            </div>
        </section>
    </div>
}

export default Blog;